/**
 * Created by liujintao on 18/10/18.
 */
import _ from 'lodash';
var list = [ { city_name: '北京',
        first_word: 'bj',
        city_code: '010',
        open_city: 1 },
        { city_name: '广州',
            first_word: 'gz',
            city_code: '020',
            open_city: 1 },
        { city_name: '深圳',
            first_word: 'sz',
            city_code: '0755',
            open_city: 1,
            brand: '学而思1对1'
         },
        { city_name: '郑州',
            first_word: 'zz',
            city_code: '0371',
            open_city: 1 },
        { city_name: '武汉',
            first_word: 'wh',
            city_code: '027',
            open_city: 1 },
        { city_name: '南京',
            first_word: 'nj',
            city_code: '025',
            open_city: 1 },
        { city_name: '苏州',
            first_word: 'suz',
            city_code: '0512',
            open_city: 1 },
        { city_name: '沈阳',
            first_word: 'sy',
            city_code: '024',
            open_city: 1 },
        { city_name: '济南',
            first_word: 'jn',
            city_code: '0531',
            open_city: 1 },
        { city_name: '西安',
            first_word: 'xa',
            city_code: '029',
            open_city: 1 },
        { city_name: '上海',
            first_word: 'sh',
            city_code: '021',
            open_city: 1 },
        { city_name: '成都',
            first_word: 'cd',
            city_code: '028',
            open_city: 1,
            brand: '学而思1对1' },
        { city_name: '天津',
            first_word: 'tj',
            city_code: '022',
            open_city: 1 },
        { city_name: '杭州',
            first_word: 'hz',
            city_code: '0571',
            open_city: 1 },
        { city_name: '重庆',
            first_word: 'cq',
            city_code: '023',
            open_city: 1 },
        {
            city_code: '0086',
            city_name: '其他',
            first_word: 'qt',
            open_city: 1
        },
        { city_name: '佛山', first_word: 'fos', city_code: '0757'},
        { city_name: '阿坝', first_word: 'ab', city_code: '0837' },
        { city_name: '阿克苏', first_word: 'aks', city_code: '0997' },
        { city_name: '阿里', first_word: 'al', city_code: '0897' },
        { city_name: '阿拉善盟', first_word: 'alsm', city_code: '0483' },
        { city_name: '澳门', first_word: 'am', city_code: '00853' },
        { city_name: '安庆', first_word: 'aq', city_code: '0556' },
        { city_name: '安顺', first_word: 'as', city_code: '0853' },
        { city_name: '鞍山', first_word: 'ans', city_code: '0412' },
        { city_name: '安阳', first_word: 'ay', city_code: '0372' },
        { city_name: '蚌埠', first_word: 'bb', city_code: '0552' },
        { city_name: '白城', first_word: 'bc', city_code: '0436' },
        { city_name: '保定', first_word: 'bd', city_code: '0312' },
        { city_name: '博尔塔拉', first_word: 'betl', city_code: '0909' },
        { city_name: '北海', first_word: 'bh', city_code: '0779' },
        { city_name: '毕节', first_word: 'bij', city_code: '0857' },
        { city_name: '宝鸡', first_word: 'baoj', city_code: '0917' },
        { city_name: '安康', first_word: 'bk', city_code: '0915' },
        { city_name: '百色', first_word: 'bs', city_code: '0776' },
        { city_name: '白山', first_word: 'bshan', city_code: '0439' },
        { city_name: '保山', first_word: 'baos', city_code: '0875' },
        { city_name: '包头', first_word: 'baot', city_code: '0472' },
        { city_name: '白银', first_word: 'by', city_code: '0943' },
        { city_name: '巴彦淖尔盟', first_word: 'bydem', city_code: '0478' },
        { city_name: '巴音郭楞', first_word: 'bygl', city_code: '0996' },
        { city_name: '滨州', first_word: 'bz', city_code: '0543' },
        { city_name: '巴中', first_word: 'baz', city_code: '0827' },
        { city_name: '长春', first_word: 'cc', city_code: '0431' },
        { city_name: '承德', first_word: 'chengd', city_code: '0314' },
        { city_name: '常德', first_word: 'cde', city_code: '0736' },
        { city_name: '昌都', first_word: 'cdu', city_code: '0895' },
        { city_name: '赤峰', first_word: 'cf', city_code: '0476' },
        { city_name: '巢湖', first_word: 'ch', city_code: '0565' },
        { city_name: '昌吉', first_word: 'cj', city_code: '0994' },
        { city_name: '长沙', first_word: 'cs', city_code: '0731',open_city:1 },
        { city_name: '楚雄', first_word: 'cx', city_code: '0878' },
        { city_name: '朝阳', first_word: 'cy', city_code: '0421' },
        { city_name: '池州', first_word: 'chiz', city_code: '0566' },
        { city_name: '滁州', first_word: 'chuz', city_code: '0550' },
        { city_name: '潮州', first_word: 'chaoz', city_code: '0768' },
        { city_name: '沧州', first_word: 'cangz', city_code: '0317' },
        { city_name: '郴州', first_word: 'chenz', city_code: '0735' },
        { city_name: '常州', first_word: 'cz', city_code: '0519' },
        { city_name: '长治', first_word: 'czhi', city_code: '0355' },
        { city_name: '丹东', first_word: 'dd', city_code: '0415' },
        { city_name: '东莞', first_word: 'dg', city_code: '0769' },
        { city_name: '德宏', first_word: 'dh', city_code: '0692' },
        { city_name: '大连', first_word: 'dl', city_code: '0411' },
        { city_name: '大理', first_word: 'dli', city_code: '0872' },
        { city_name: '大庆', first_word: 'daq', city_code: '0459' },
        { city_name: '迪庆', first_word: 'diq', city_code: '0887' },
        { city_name: '大同', first_word: 'dt', city_code: '0352' },
        { city_name: '定西', first_word: 'dx', city_code: '0932' },
        { city_name: '大兴安岭', first_word: 'dxal', city_code: '0457' },
        { city_name: '东营', first_word: 'dy', city_code: '0546' },
        { city_name: '德阳', first_word: 'dey', city_code: '0838' },
        { city_name: '德州', first_word: 'dz', city_code: '0534' },
        { city_name: '达州', first_word: 'daz', city_code: '0818' },
        { city_name: '鄂尔多斯', first_word: 'eeds', city_code: '0477' },
        { city_name: '恩施', first_word: 'es', city_code: '0718' },
        { city_name: '鄂州', first_word: 'ez', city_code: '0711' },
        { city_name: '防城港', first_word: 'fcg', city_code: '0770' },
        { city_name: '阜新', first_word: 'fx', city_code: '0418' },
        { city_name: '阜阳', first_word: 'fy', city_code: '0558' },
        { city_name: '福州', first_word: 'fz', city_code: '0591' },
        { city_name: '抚州', first_word: 'fuz', city_code: '0794' },
        { city_name: '广安', first_word: 'ga', city_code: '0826' },
        { city_name: '贵港', first_word: 'gg', city_code: '0775' },
        { city_name: '桂林', first_word: 'guil', city_code: '0773' },
        { city_name: '果洛', first_word: 'gl', city_code: '0975' },
        { city_name: '甘南', first_word: 'gn', city_code: '0941' },
        { city_name: '贵阳', first_word: 'gy', city_code: '0851' },
        { city_name: '固原', first_word: 'guy', city_code: '0954' },
        { city_name: '广元', first_word: 'guangy', city_code: '0839' },
        { city_name: '赣州', first_word: 'ganz', city_code: '0797' },
        { city_name: '甘孜', first_word: 'gzi', city_code: '0836' },
        { city_name: '淮安', first_word: 'ha', city_code: '0517' },
        { city_name: '淮北', first_word: 'hb', city_code: '0561' },
        { city_name: '鹤壁', first_word: 'hbi', city_code: '0392' },
        { city_name: '海北', first_word: 'haib', city_code: '0970' },
        { city_name: '河池', first_word: 'hc', city_code: '0778' },
        { city_name: '邯郸', first_word: 'hd', city_code: '0310' },
        { city_name: '海东', first_word: 'haid', city_code: '0972' },
        { city_name: '哈尔滨', first_word: 'heb', city_code: '0451' },
        { city_name: '合肥', first_word: 'hf', city_code: '0551' },

        { city_name: '鹤岗', first_word: 'heg', city_code: '0468' },
        { city_name: '黄冈', first_word: 'hg', city_code: '0713' },
        { city_name: '黑河', first_word: 'heih', city_code: '0456' },
        { city_name: '怀化', first_word: 'hh', city_code: '0745' },
        { city_name: '红河', first_word: 'hhe', city_code: '0873' },
        { city_name: '呼和浩特', first_word: 'hhht', city_code: '0471' },
        { city_name: '呼伦贝尔', first_word: 'hlbe', city_code: '0470' },
        { city_name: '葫芦岛', first_word: 'hld', city_code: '0429' },
        { city_name: '哈密', first_word: 'hm', city_code: '0902' },
        { city_name: '淮南', first_word: 'huain', city_code: '0554' },
        { city_name: '海南', first_word: 'hn', city_code: '0898' },
        { city_name: '黄南', first_word: 'huangn', city_code: '0973' },
        { city_name: '黄山', first_word: 'hs', city_code: '0559' },
        { city_name: '衡水', first_word: 'huangs', city_code: '0318' },
        { city_name: '黄石', first_word: 'hshi', city_code: '0714' },
        { city_name: '和田', first_word: 'ht', city_code: '0903' },
        { city_name: '海西', first_word: 'hx', city_code: '0979' },
        { city_name: '河源', first_word: 'hey', city_code: '0762' },
        { city_name: '衡阳', first_word: 'hy', city_code: '0734' },
        { city_name: '惠州', first_word: 'huiz', city_code: '0752' },
        { city_name: '贺州', first_word: 'hez', city_code: '0774' },
        { city_name: '菏泽', first_word: 'hze', city_code: '0530' },
        { city_name: '汉中', first_word: 'hanz', city_code: '0916' },
        { city_name: '湖州', first_word: 'huz', city_code: '0572' },
        { city_name: '吉安', first_word: 'ja', city_code: '0796' },
        { city_name: '晋城', first_word: 'jc', city_code: '0356' },
        { city_name: '景德镇', first_word: 'jdz', city_code: '0798' },
        { city_name: '金华', first_word: 'jh', city_code: '0579' },
        { city_name: '金昌', first_word: 'jj', city_code: '0935' },
        { city_name: '九江', first_word: 'jiuj', city_code: '0792' },
        { city_name: '吉林', first_word: 'jl', city_code: '0432' },
        { city_name: '江门', first_word: 'jm', city_code: '0750' },
        { city_name: '荆门', first_word: 'jim', city_code: '0724' },
        { city_name: '佳木斯', first_word: 'jms', city_code: '0454' },
        { city_name: '济宁', first_word: 'jin', city_code: '0537' },
        { city_name: '酒泉', first_word: 'jq', city_code: '0937' },
        { city_name: '鸡西', first_word: 'jix', city_code: '0467' },
        { city_name: '嘉兴', first_word: 'jx', city_code: '0573' },
        { city_name: '揭阳', first_word: 'jiey', city_code: '0663' },
        { city_name: '焦作', first_word: 'jz', city_code: '0391' },
        { city_name: '荆州', first_word: 'jiz', city_code: '0716' },
        { city_name: '锦州', first_word: 'jinz', city_code: '0416' },
        { city_name: '晋中', first_word: 'jzhong', city_code: '0354' },
        { city_name: '克拉玛依', first_word: 'klmy', city_code: '0990' },
        { city_name: '昆明', first_word: 'km', city_code: '0871' },
        { city_name: '喀什', first_word: 'ks', city_code: '0998' },
        { city_name: '克孜勒苏', first_word: 'kzls', city_code: '0908' },
        { city_name: '六安', first_word: 'la', city_code: '0564' },
        { city_name: '聊城', first_word: 'lc', city_code: '0635' },
        { city_name: '临沧', first_word: 'linc', city_code: '0883' },
        { city_name: '娄底', first_word: 'ld', city_code: '0738' },
        { city_name: '廊坊', first_word: 'lf', city_code: '0316' },
        { city_name: '漯河', first_word: 'lh', city_code: '0395' },
        { city_name: '丽江', first_word: 'lj', city_code: '0888' },
        { city_name: '吕梁', first_word: 'll', city_code: '0358' },
        { city_name: '陇南', first_word: 'ln', city_code: '0939' },
        { city_name: '六盘水', first_word: 'lps', city_code: '0858' },
        { city_name: '乐山', first_word: 'les', city_code: '0833' },
        { city_name: '凉山', first_word: 'liangs', city_code: '0834' },
        { city_name: '拉萨', first_word: 'ls', city_code: '0891' },
        { city_name: '丽水', first_word: 'lis', city_code: '0578' },
        { city_name: '莱芜', first_word: 'lw', city_code: '0634' },
        { city_name: '临夏', first_word: 'linx', city_code: '0930' },
        { city_name: '临沂', first_word: 'liny', city_code: '0539' },
        { city_name: '临汾', first_word: 'linf', city_code: '0357' },
        { city_name: '龙岩', first_word: 'ly', city_code: '0597' },
        { city_name: '洛阳', first_word: 'luoy', city_code: '0379' },
        { city_name: '辽源', first_word: 'liaoy', city_code: '0437' },
        { city_name: '辽阳', first_word: 'lyang', city_code: '0419' },
        { city_name: '连云港', first_word: 'lyg', city_code: '0518' },
        { city_name: '兰州', first_word: 'lz', city_code: '0931' },
        { city_name: '柳州', first_word: 'liuz', city_code: '0772' },
        { city_name: '泸州', first_word: 'luz', city_code: '0830' },
        { city_name: '林芝', first_word: 'linz', city_code: '0894' },
        { city_name: '马鞍山', first_word: 'mas', city_code: '0555' },
        { city_name: '牡丹江', first_word: 'mdj', city_code: '0453' },
        { city_name: '茂名', first_word: 'mm', city_code: '0668' },
        { city_name: '绵阳', first_word: 'my', city_code: '0816' },
        { city_name: '梅州', first_word: 'mz', city_code: '0753' },
        { city_name: '宁波', first_word: 'nb', city_code: '0574' },
        { city_name: '南充', first_word: 'nanc', city_code: '0817' },
        { city_name: '宁德', first_word: 'nd', city_code: '0593' },
        { city_name: '南昌', first_word: 'nc', city_code: '0791' },
        { city_name: '内江', first_word: 'neij', city_code: '0832' },
        { city_name: '怒江', first_word: 'nuj', city_code: '0886' },
        { city_name: '南宁', first_word: 'nn', city_code: '0771' },
        { city_name: '南平', first_word: 'np', city_code: '0599' },
        { city_name: '那曲', first_word: 'nq', city_code: '0896' },
        { city_name: '南通', first_word: 'nt', city_code: '0513' },
        { city_name: '南阳', first_word: 'ny', city_code: '0377' },

        { city_name: '平顶山', first_word: 'pds', city_code: '0375' },
        { city_name: '普洱', first_word: 'pe', city_code: '0879' },
        { city_name: '盘锦', first_word: 'pj', city_code: '0427' },
        { city_name: '平凉', first_word: 'pl', city_code: '0933' },
        { city_name: '莆田', first_word: 'pt', city_code: '0594' },
        { city_name: '萍乡', first_word: 'px', city_code: '0799' },
        { city_name: '濮阳', first_word: 'py', city_code: '0393' },
        { city_name: '攀枝花', first_word: 'pzh', city_code: '0812' },
        { city_name: '青岛', first_word: 'qd', city_code: '0532',open_city:1},
        { city_name: '黔东南', first_word: 'qdn', city_code: '0855' },
        { city_name: '秦皇岛', first_word: 'qhd', city_code: '0335' },
        { city_name: '曲靖', first_word: 'qj', city_code: '0874' },
        { city_name: '黔南', first_word: 'qn', city_code: '0854' },
        { city_name: '齐齐哈尔', first_word: 'qqhe', city_code: '0452' },
        { city_name: '七台河', first_word: 'qth', city_code: '0464' },
        { city_name: '黔西南', first_word: 'qxn', city_code: '0859' },
        { city_name: '庆阳', first_word: 'qingy', city_code: '0934' },
        { city_name: '清远', first_word: 'qy', city_code: '0763' },
        { city_name: '泉州', first_word: 'qz', city_code: '0595' },
        { city_name: '钦州', first_word: 'qinz', city_code: '0777' },
        { city_name: '泰州', first_word: 'taiz', city_code: '0523' },
        { city_name: '衢州', first_word: 'quz', city_code: '0570' },
        { city_name: '日喀则', first_word: 'rkz', city_code: '0892' },
        { city_name: '日照', first_word: 'rz', city_code: '0633' },
        { city_name: '韶关', first_word: 'sg', city_code: '0751' },
        { city_name: '绥化', first_word: 'suih', city_code: '0455' },
        { city_name: '石河子', first_word: 'shz', city_code: '0993' },
        { city_name: '石家庄', first_word: 'sjz', city_code: '0311' },
        { city_name: '商洛', first_word: 'sl', city_code: '0914' },
        { city_name: '三明', first_word: 'sm', city_code: '0598' },
        { city_name: '三门峡', first_word: 'smx', city_code: '0398' },
        { city_name: '遂宁', first_word: 'suin', city_code: '0825' },
        { city_name: '山南', first_word: 'sn', city_code: '0893' },
        { city_name: '四平', first_word: 'sp', city_code: '0434' },
        { city_name: '商丘', first_word: 'sq', city_code: '0370' },
        { city_name: '宿迁', first_word: 'suq', city_code: '0527' },
        { city_name: '上饶', first_word: 'sr', city_code: '0793' },
        { city_name: '汕头', first_word: 'st', city_code: '0754' },
        { city_name: '汕尾', first_word: 'sw', city_code: '0660' },
        { city_name: '绍兴', first_word: 'sx', city_code: '0575' },
        { city_name: '十堰', first_word: 'shiy', city_code: '0719' },
        { city_name: '松原', first_word: 'songy', city_code: '0438' },
        { city_name: '双鸭山', first_word: 'sys', city_code: '0469' },
        { city_name: '宿州', first_word: 'szhou', city_code: '0557' },
        { city_name: '随州', first_word: 'suiz', city_code: '0722' },
        { city_name: '朔州', first_word: 'shuoz', city_code: '0349' },
        { city_name: '石嘴山', first_word: 'szs', city_code: '0952' },
        { city_name: '泰安', first_word: 'ta', city_code: '0538' },
        { city_name: '铜川', first_word: 'tc', city_code: '0919' },
        { city_name: '通化', first_word: 'th', city_code: '0435' },
        { city_name: '铜陵', first_word: 'tongl', city_code: '0562' },
        { city_name: '通辽', first_word: 'tl', city_code: '0475' },
        { city_name: '吐鲁番', first_word: 'tlf', city_code: '0995' },
        { city_name: '天门', first_word: 'tm', city_code: '0728' },
        { city_name: '铜仁', first_word: 'tr', city_code: '0856' },
        { city_name: '天水', first_word: 'tians', city_code: '0938' },
        { city_name: '唐山', first_word: 'ts', city_code: '0315' },
        { city_name: '台湾', first_word: 'tw', city_code: '00886' },
        { city_name: '太原', first_word: 'ty', city_code: '0351',open_city:1},
        { city_name: '台州', first_word: 'tz', city_code: '0576' },

        { city_name: '潍坊', first_word: 'wf', city_code: '0536' },
        { city_name: '芜湖', first_word: 'wuh', city_code: '0553' },
        { city_name: '乌海', first_word: 'whai', city_code: '0473' },
        { city_name: '威海', first_word: 'weih', city_code: '0631' },
        { city_name: '乌兰察布', first_word: 'wlcbs', city_code: '0474' },
        { city_name: '乌鲁木齐', first_word: 'wlmq', city_code: '0991' },
        { city_name: '渭南', first_word: 'wn', city_code: '0913' },
        { city_name: '文山', first_word: 'ws', city_code: '0876' },
        { city_name: '无锡', first_word: 'wx', city_code: '0510' },
        { city_name: '吴忠', first_word: 'wzhong', city_code: '0953' },
        { city_name: '温州', first_word: 'wz', city_code: '0577' },
        { city_name: '兴安盟', first_word: 'xam', city_code: '0482' },
        { city_name: '宣城', first_word: 'xc', city_code: '0563' },
        { city_name: '许昌', first_word: 'xuc', city_code: '0374' },
        { city_name: '襄樊', first_word: 'xf', city_code: '0710' },
        { city_name: '孝感', first_word: 'xiaog', city_code: '0712' },
        { city_name: '香港', first_word: 'xg', city_code: '00852' },
        { city_name: '锡林郭勒盟', first_word: 'xlglm', city_code: '0479' },
        { city_name: '厦门', first_word: 'xm', city_code: '0592' },
        { city_name: '咸宁', first_word: 'xiann', city_code: '0715' },
        { city_name: '西宁', first_word: 'xn', city_code: '0971' },
        { city_name: '西双版纳', first_word: 'xsbn', city_code: '0691' },
        { city_name: '邢台', first_word: 'xingt', city_code: '0319' },
        { city_name: '湘潭', first_word: 'xt', city_code: '0739' },
        { city_name: '新乡', first_word: 'xinx', city_code: '0373' },
        { city_name: '湘西', first_word: 'xx', city_code: '0743' },
        { city_name: '信阳', first_word: 'xiny', city_code: '0376' },
        { city_name: '新余', first_word: 'xyu', city_code: '0790' },
        { city_name: '徐州', first_word: 'xz', city_code: '0516' },
        { city_name: '忻州', first_word: 'xinz', city_code: '0350' },
        { city_name: '延安', first_word: 'yana', city_code: '0911' },
        { city_name: '雅安', first_word: 'ya', city_code: '0835' },
        { city_name: '延边', first_word: 'yb', city_code: '0433' },
        { city_name: '宜宾', first_word: 'yib', city_code: '0831' },
        { city_name: '伊春', first_word: 'yic', city_code: '0458' },
        { city_name: '宜昌', first_word: 'ychang', city_code: '0717' },
        { city_name: '盐城', first_word: 'yanc', city_code: '0515' },
        { city_name: '宜春', first_word: 'ychun', city_code: '0795' },
        { city_name: '银川', first_word: 'yc', city_code: '0951' },
        { city_name: '运城', first_word: 'yunc', city_code: '0359' },
        { city_name: '云浮', first_word: 'yf', city_code: '0766' },
        { city_name: '阳江', first_word: 'yj', city_code: '0662' },
        { city_name: '营口', first_word: 'yk', city_code: '0417' },
        { city_name: '榆林', first_word: 'ylin', city_code: '0912' },
        { city_name: '伊犁', first_word: 'yl', city_code: '0999' },
        { city_name: '阳泉', first_word: 'yq', city_code: '0353' },
        { city_name: '玉树', first_word: 'ys', city_code: '0976' },
        { city_name: '鹰潭', first_word: 'ytan', city_code: '0701' },
        { city_name: '烟台', first_word: 'yt', city_code: '0535' },
        { city_name: '玉溪', first_word: 'yx', city_code: '0877' },
        { city_name: '益阳', first_word: 'yiy', city_code: '0737' },
        { city_name: '岳阳', first_word: 'yy', city_code: '0730' },
        { city_name: '永州', first_word: 'yongz', city_code: '0746' },
        { city_name: '扬州', first_word: 'yz', city_code: '0514' },
        { city_name: '淄博', first_word: 'zb', city_code: '0533' },
        { city_name: '自贡', first_word: 'zg', city_code: '0813' },
        { city_name: '珠海', first_word: 'zh', city_code: '0756' },
        { city_name: '湛江', first_word: 'zhanj', city_code: '0759' },
        { city_name: '镇江', first_word: 'zj', city_code: '0511' },
        { city_name: '张家界', first_word: 'zjj', city_code: '0744' },
        { city_name: '张家口', first_word: 'zjk', city_code: '0313' },
        { city_name: '周口', first_word: 'zk', city_code: '0394' },
        { city_name: '驻马店', first_word: 'zmd', city_code: '0396' },
        { city_name: '肇庆', first_word: 'zq', city_code: '0758' },
        { city_name: '中山', first_word: 'zs', city_code: '0760' },
        { city_name: '舟山', first_word: 'zhous', city_code: '0580' },
        { city_name: '昭通', first_word: 'zt', city_code: '0870' },
        { city_name: '中卫', first_word: 'zw', city_code: '0955' },
        { city_name: '张掖', first_word: 'zye', city_code: '0936' },
        { city_name: '漳州', first_word: 'zhangz', city_code: '0596' },
        { city_name: '枣庄', first_word: 'zaoz', city_code: '0632' }
    ];
export default {
    allCities: _.reject(list,{open_city:1}),
    openCities:_.filter(list,{open_city:1}),
    getCityByCode(city_code){
        var city = _.find(list,{city_code:city_code});
        return city||{city_code:'010',city_name:'北京',open_city:true};
    },
    getCityByShort(short){
        var city = _.find(list,{first_word:short});
        return city||{city_code:'010',city_name:'北京',open_city:true};
    }
}


// WEBPACK FOOTER //
// ./src/common/libs/CityCodeData.js